import axios from '@/api/config';

const integral = {
  getIntegralById(data) {
    return axios.get(`${process.env.BASE_URL}/integral/getIntegralById/` + data, {});
  },
  getIntegralDetail(data) {
    return axios.get(`${process.env.BASE_URL}/integral/getIntegralDetail`, {params: data});
  },
  getIntegral(data) {
    return axios.get(`${process.env.BASE_URL}/integral/getIntegral`, {params: data});
  },
  getIntegralList(data) {
    return axios.get(`${process.env.BASE_URL}/integral/getIntegralList`, {params: data});
  },
  getIntegralTree(data) {
    return axios.get(`${process.env.BASE_URL}/integral/getIntegralTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/integral/pageList`, data);
  },
  addIntegral(data) {
    return axios.post(`${process.env.BASE_URL}/integral/addIntegral`, data);
  },
  updateIntegral(data) {
    return axios.put(`${process.env.BASE_URL}/integral/updateIntegral`, data);
  },
  deleteIntegral(data) {
    return axios.delete(`${process.env.BASE_URL}/integral/deleteIntegral`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/integral/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/integral/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/integral/active`, data);
  },
}

export default integral;



// WEBPACK FOOTER //
// ./src/api/integral.js